export var TypeNumberFormat;
(function (TypeNumberFormat) {
    TypeNumberFormat[TypeNumberFormat["None"] = 0] = "None";
    TypeNumberFormat[TypeNumberFormat["Subtract"] = 1] = "Subtract";
    TypeNumberFormat[TypeNumberFormat["Add"] = 2] = "Add";
    TypeNumberFormat[TypeNumberFormat["AddExceptZero"] = 3] = "AddExceptZero";
    TypeNumberFormat[TypeNumberFormat["AddIncludingZero"] = 4] = "AddIncludingZero";
    TypeNumberFormat[TypeNumberFormat["Unsigned"] = 5] = "Unsigned";
    TypeNumberFormat[TypeNumberFormat["SignedPercent"] = 6] = "SignedPercent";
    TypeNumberFormat[TypeNumberFormat["Percent"] = 7] = "Percent";
    TypeNumberFormat[TypeNumberFormat["RoundedPercent"] = 8] = "RoundedPercent";
    TypeNumberFormat[TypeNumberFormat["Multiplication"] = 9] = "Multiplication";
})(TypeNumberFormat || (TypeNumberFormat = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/number-format/TypeNumberFormat.ts
// module id = 43
// module chunks = 3